module.exports = __webpack_public_path__ + "static/image/meituan.svg?e1e43dd551feb0efe1f9692e5b7fd120";